import dayjs from 'dayjs';
import 'dayjs/locale/uk';

export default {
  install: (app) => {
    dayjs.locale('uk');
    app.config.globalProperties.$dayjs = dayjs;
  }
}
